var VatInfoDisplayMode = /* @__PURE__ */ ((VatInfoDisplayMode2) => {
  VatInfoDisplayMode2["NONE"] = "none";
  VatInfoDisplayMode2["INCLUDE"] = "include";
  VatInfoDisplayMode2["EXCLUDE"] = "exclude";
  return VatInfoDisplayMode2;
})(VatInfoDisplayMode || {});
const WsPriceBadgeEnum = {
  VatInfoDisplayMode
};
export {
  VatInfoDisplayMode,
  WsPriceBadgeEnum
};
//# sourceMappingURL=WsPriceBadge.enum.es.js.map
